import React from 'react';
import Layout from '~/components/layout/_layout';
import { t } from "@lingui/macro";
import SEO from "~/components/seo";
import LeadFormOcellot from '~/components/forms/ocellot-lead-form';
import getConfig from 'next/config';
import PAGE_TYPES from "../../../src/page_types";

const { publicRuntimeConfig } = getConfig();

function SignUp() {
    return (
        <Layout welcome={false} page={PAGE_TYPES.OCELLOT}>
            <SEO
                title={t`cz.ocellot.sign_up.seo.title`}
                description={t`cz.ocellot.sign_up.seo.description`}
            />
            <LeadFormOcellot googleScript={publicRuntimeConfig.FORM.OCELLOT} />
        </Layout>
    );
}

export default SignUp;
